import { PERMISSIONS } from '@core/constants/permissions.constants'

export const SHIKSHA_FEATURES = {
    CREATE: 'CREATE',
    VIEW: 'VIEW',
    BULK_UPLOAD: 'BULK_UPLOAD',
    VIEW_DEAL: 'VIEW_DEAL',
    CREATE_DEAL: 'CREATE_DEAL',
} as const

export const SHIKSHA_PERMISSION_CONFIG = {
    [SHIKSHA_FEATURES.CREATE]: [PERMISSIONS.ADD_NEW_CLIENT, PERMISSIONS.CREATE_CLIENT_SHIKSHA],
    [SHIKSHA_FEATURES.VIEW]: [PERMISSIONS.VIEW_CLIENT_SHIKSHA],
    [SHIKSHA_FEATURES.BULK_UPLOAD]: [PERMISSIONS.ADD_NEW_CLIENT],
    [SHIKSHA_FEATURES.VIEW_DEAL]: [PERMISSIONS.VIEW_DEAL_SHIKSHA],
    [SHIKSHA_FEATURES.CREATE_DEAL]: [PERMISSIONS.CREATE_DEAL_SHIKSHA],
} as const

export type ShikshaFeature = keyof typeof SHIKSHA_PERMISSION_CONFIG
